// import $ from "jquery";

import {Carousel} from "bootstrap";

var TOOLSBOOTSTRAP = function () {
  // ============================================================================
  this.bsShowDialog = function (obj) {
    var iddialog = obj.attr("data-iddialog");
    if (iddialog == undefined) return false;

    $("#" + iddialog).addClass("show");
    $("#" + iddialog).show();

    return false;
  };

  // ============================================================================
  this.bsCloseDialog = function (obj) {
    var iddialog = obj.attr("data-iddialog");
    if (iddialog == undefined) return false;

    $("#" + iddialog).removeClass("show");
    $("#" + iddialog).hide();

    return false;
  };

  // ============================================================================
  this.bsSetCarousel = function (obj) {
    var carousel = Carousel.getInstance(obj);
    if (!carousel) {
      new Carousel(obj);
    }
  };

  // ============================================================================
};

var toolsBootstrap = new TOOLSBOOTSTRAP();

export default toolsBootstrap;
